export default __webpack_public_path__ + "static/media/trophy.97251ba6.svg";